import { Component, computed, DestroyRef, effect, inject, LOCALE_ID, signal } from '@angular/core';
import { FilterDateComponent } from '../../../shared/ui/shared-filters/filter-date-component/filter-date-component';
import { FilterItemSearch } from '../../../shared/ui/shared-filters/filter-item-search/filter-item-search';
import { FilterSortingComponent } from '../../../shared/ui/shared-filters/filter-sorting-component/filter-sorting-component';
import { SubmitButton } from '../../../shared/ui/Buttons/submit-button/submit-button';
import { FilterMultiSelectComponent } from '../../../shared/ui/shared-filters/filter-multi-select-component/filter-multi-select-component';
import { Router } from '@angular/router';
import { PharmacyCreditService } from '../../../services/pharmacy-credit/pharmacy-credit';
import { PharmacyAutoComplete } from '../../admin-dashboard-component/invoice-list-component/shared/pharmacy-auto-complete/pharmacy-auto-complete';
import { PharmacyAutoCompleteApiItem } from '../../../services/pharmace-auto-complete/pharmace-auto-complete.service';
import { validateInvoiceDates } from '../../admin-dashboard-component/invoice-list-component/invoice-list-component.validation';
import { Pagination } from '../../../shared/ui/shared-tables/pagination/pagination';
import { CardHeaderItem, CardList } from '../invoice-list-pharmacist/shared/card-list/card-list';

@Component({
  selector: 'app-returns-list-ph-component',
  imports: [FilterDateComponent, FilterItemSearch, FilterSortingComponent, SubmitButton, FilterMultiSelectComponent, PharmacyAutoComplete, Pagination, CardList],
  templateUrl: './returns-list-ph-component.html',
  styleUrl: './returns-list-ph-component.scss',
})
export class ReturnsListPhComponent {
private router = inject(Router);
  private locale = inject(LOCALE_ID);
  private pharmacyCreditService = inject(PharmacyCreditService);
  private destroyRef = inject(DestroyRef);

  selectedPharmacy = computed(() => this.pharmacyCreditService.selectedPharmacy());

  constructor() {
    effect(() => {
      const pharmacy = this.selectedPharmacy();
      if (!pharmacy) return;

      this.currentPage.set(1);
      // loadReturnRequests();
    });
  }

  isArabic = computed(() => this.locale.startsWith('ar'));
  loading = signal(false);
  errorMessage = signal<string | null>(null);


  orderIdFilter = $localize`:@@returnsOrderIdFilter:Order ID`;
  orderIdPlaceholder = $localize`:@@returnsOrderIdPlaceholder:Enter Order ID`;
  orderSearch = signal('');
  orderIdError = signal<string | null>(null);

  onOrderIdChange(value: string) {
    this.orderSearch.set(value);
    if (value && !/^\d+$/.test(value)) {
      const msg = this.isArabic()
        ? 'يجب أن يحتوي رقم الطلب على أرقام فقط.'
        : 'Order ID must contain numbers only.';
      this.orderIdError.set(msg);
    } else {
      this.orderIdError.set(null);
    }
  }


  pharmacyFilterLabel = $localize`:@@returnsPharmacyFilter:Pharmacy `;
  pharmacyPlaceholder = $localize`:@@returnsPharmacyPlaceholder:Search pharmacy`;
  noPharmaciesFoundText = $localize`:@@noPharmaciesFound:No pharmacies found`;
  selectedPharmacyFilter = signal<PharmacyAutoCompleteApiItem | null>(null);
  clearPharmacySignal = signal(0);

  onPharmacySelected(pharmacy: PharmacyAutoCompleteApiItem) {
    this.selectedPharmacyFilter.set(pharmacy);
  }


  statusFilter = { titleEn: 'Status', titleAr: 'الحالة' };
  allStatuses = { titleEn: 'Select Status', titleAr: 'حدد الحالة' };

  statusOptions = [
    { id: 'PENDING_REVIEW', titleEn: 'Pending Review', titleAr: 'قيد المراجعة' },
    { id: 'MODIFICATION_REQUESTED', titleEn: 'Modification Requested', titleAr: 'يحتاج إلى تعديل' },
    { id: 'ACCEPTED', titleEn: 'Accepted', titleAr: 'مقبول' },
    { id: 'PICKED_UP', titleEn: 'Picked up', titleAr: 'تم استلام الموزع' },
    { id: 'PRODUCTS_RETURNS_RECEIVED', titleEn: 'Products Returns Received', titleAr: 'تم استلام المخزون' },
    { id: 'CANCELLED', titleEn: 'Cancelled', titleAr: 'ملغي' },
    { id: 'CLOSED', titleEn: 'Closed', titleAr: 'مكتمل' },
  ];

  selectedStatuses = signal<string[]>([]);
  showStatusDropdown = signal(false);

  toggleStatusDropdown() {
    this.showStatusDropdown.update((val) => !val);
  }

  onStatusChange(statuses: string[]) {
    this.selectedStatuses.set(statuses);
  }


  createdDateFromLabel = $localize`:@@returnsCreatedDateFromLabel:Created Date From`;
  createdDateToLabel = $localize`:@@returnsCreatedDateToLabel:Created Date To`;
  createdFromPlaceholder = $localize`:@@returnsCreatedFromPlaceholder:From date`;
  createdToPlaceholder = $localize`:@@returnsCreatedToPlaceholder:To date`;

  createdFrom = signal<string | null>(null);
  createdTo = signal<string | null>(null);

  fromDateError = signal<string | null>(null);
  toDateError = signal<string | null>(null);

  validateDates() {
    const result = validateInvoiceDates(this.createdFrom(), this.createdTo(), this.isArabic());

    this.fromDateError.set(result.fromDateError);
    this.toDateError.set(result.toDateError);

    return result.isValid;
  }

  onFromDateChange(value: string | null) {
    this.createdFrom.set(value);
    this.validateDates();
  }

  onToDateChange(value: string | null) {
    this.createdTo.set(value);
    this.validateDates();
  }


  createdByFilter = $localize`:@@returnsCreatedByFilter:Created By`;
  createdByPlaceholder = $localize`:@@returnsCreatedByPlaceholder:Search user`;
  createdBySearch = signal('');


  orderBy = signal('LAST_MODIFIED_ON');
  orderDir = signal<'ASC' | 'DESC'>('DESC');

  sortOptions = [
    { value: 'LAST_MODIFIED_ON', labelEn: 'Last Modified On', labelAr: 'تاريخ التعديل' },
    { value: 'CREATED_ON', labelEn: 'Created On', labelAr: 'تاريخ الإنشاء' },
    { value: 'RETURN_AMOUNT', labelEn: 'Return Value', labelAr: 'قيمة المرتجع' },
    { value: 'STATUS', labelEn: 'Status', labelAr: 'الحالة' },
  ];

  toggleSortOrder() {
    this.orderDir.update((dir) => (dir === 'DESC' ? 'ASC' : 'DESC'));
  }

  
  itemsPerPage = signal(25);
  currentPage = signal(1);
  totalItems = signal(0);

  emptyFilterTitle = {
    ar: 'لا توجد مناطق مطابقة لمعايير البحث.',
    en: 'No zones match the search criteria.',
  };

  applyFilters() {
    const isDateValid = this.validateDates();
    const isOrderIdValid = !this.orderIdError();

    if (!isDateValid || !isOrderIdValid) {
      return;
    }

  
    this.currentPage.set(1);

    console.log('Filters Applied:', {
      orderId: this.orderSearch(),
      pharmacyId: this.selectedPharmacyFilter()?.id,
      statuses: this.selectedStatuses(),
      createdFrom: this.createdFrom(),
      createdTo: this.createdTo(),
      createdBy: this.createdBySearch(),
      orderBy: this.orderBy(),
      orderDir: this.orderDir(),
      page: this.currentPage(),
      limit: this.itemsPerPage(),
    });
  }

  resetFilters() {
    this.orderSearch.set('');
    this.orderIdError.set(null);

    this.selectedPharmacyFilter.set(null);
    this.clearPharmacySignal.update((v) => v + 1);

    this.selectedStatuses.set([]);

    this.createdFrom.set(null);
    this.createdTo.set(null);
    this.fromDateError.set(null);
    this.toDateError.set(null);

    this.createdBySearch.set('');

    this.orderBy.set('LAST_MODIFIED_ON');
    this.orderDir.set('DESC');

    this.currentPage.set(1);
  }



  returnHeaderItems: CardHeaderItem[] = [
    {
      key: 'id', 
      labelAr: 'رقم طلب المرتجع',
      labelEn: 'Return Request ID',
      position: 'header',
    },
    {
      key: 'status', 
      labelAr: 'الحالة',
      labelEn: 'Status',
      type: 'status',
      position: 'header',
    },
    {
      key: 'orderId', 
      labelAr: 'رقم الطلب',
      labelEn: 'Order ID',
      position: 'body',
    },
    {
      key: 'returnValue', 
      labelAr: 'قيمة المرتجع',
      labelEn: 'Return Value',
      type: 'currency',
      position: 'footer',
    },
    {
      key: 'createdAt',
      labelAr: 'تاريخ الإنشاء',
      labelEn: 'Created On',
      type: 'date',
      position: 'footer',
    },
    {
      key: 'createdBy',
      labelAr: 'تم الإنشاء بواسطة',
      labelEn: 'Created By',
      position: 'footer',
    },
  ];

  
returnRows = [
  {
    id: '24110526081',
    orderId: '2411526081',
    returnValue: 1500,
    status: { titleAr: 'مدفوع جزئياً', titleEn: 'Partially Paid' },
    createdAt: new Date('2026-01-15T14:30:25'),
    createdBy: 'النظام',
  },
  {
    id: '24110526082',
    orderId: '2411526082',
    returnValue: 2200,
    status: { titleAr: 'مدفوع', titleEn: 'Paid' },
    createdAt: new Date('2026-01-16T10:15:00'),
    createdBy: 'أحمد محمود',
  },
  {
    id: '24110526083',
    orderId: '2411526083',
    returnValue: 850,
    status: { titleAr: 'قيد الانتظار', titleEn: 'Pending' },
    createdAt: new Date('2026-01-17T09:45:10'),
    createdBy: 'النظام',
  },
  {
    id: '24110526084',
    orderId: '2411526084',
    returnValue: 1200,
    status: { titleAr: 'قيد المراجعة', titleEn: 'Pending Review' },
    createdAt: new Date('2026-01-18T11:20:00'),
    createdBy: 'سارة علي',
  },
  {
    id: '24110526085',
    orderId: '2411526085',
    returnValue: 3100,
    status: { titleAr: 'يحتاج إلى تعديل', titleEn: 'Modification Requested' },
    createdAt: new Date('2026-01-19T13:10:45'),
    createdBy: 'محمد مصطفى',
  },
  {
    id: '24110526086',
    orderId: '2411526086',
    returnValue: 500,
    status: { titleAr: 'مقبول', titleEn: 'Accepted' },
    createdAt: new Date('2026-01-20T16:05:30'),
    createdBy: 'النظام',
  },
  {
    id: '24110526087',
    orderId: '2411526087',
    returnValue: 1750,
    status: { titleAr: 'تم التوصيل', titleEn: 'Delivered' },
    createdAt: new Date('2026-01-21T08:30:00'),
    createdBy: 'شركة الشحن',
  },
  {
    id: '24110526088',
    orderId: '2411526088',
    returnValue: 2400,
    status: { titleAr: 'تم التوصيل جزئياً', titleEn: 'Partially Delivered' },
    createdAt: new Date('2026-01-22T12:00:15'),
    createdBy: 'شركة الشحن',
  },
  {
    id: '24110526089',
    orderId: '2411526089',
    returnValue: 980,
    status: { titleAr: 'تم استلام الموزع', titleEn: 'Picked up' },
    createdAt: new Date('2026-01-23T15:40:20'),
    createdBy: 'مندوب التوصيل',
  },
  {
    id: '24110526090',
    orderId: '2411526090',
    returnValue: 1350,
    status: { titleAr: 'تمت الطباعة', titleEn: 'Printed' },
    createdAt: new Date('2026-01-24T10:00:00'),
    createdBy: 'مسؤول المخزن',
  },
  {
    id: '24110526091',
    orderId: '2411526091',
    returnValue: 4100,
    status: { titleAr: 'تم استلام المخزون', titleEn: 'Products Returns Received' },
    createdAt: new Date('2026-01-25T14:15:50'),
    createdBy: 'أمين المخزن',
  },
  {
    id: '24110526092',
    orderId: '2411526092',
    returnValue: 620,
    status: { titleAr: 'مغلق', titleEn: 'Closed' },
    createdAt: new Date('2026-01-26T17:25:00'),
    createdBy: 'النظام',
  },
  {
    id: '24110526093',
    orderId: '2411526093',
    returnValue: 1900,
    status: { titleAr: 'مكتمل', titleEn: 'Completed' },
    createdAt: new Date('2026-01-27T09:10:00'),
    createdBy: 'النظام',
  },
  {
    id: '24110526094',
    orderId: '2411526094',
    returnValue: 800,
    status: { titleAr: 'ملغي', titleEn: 'Cancelled' },
    createdAt: new Date('2026-01-28T11:55:30'),
    createdBy: 'العميل',
  },
  {
    id: '24110526095',
    orderId: '2411526095',
    returnValue: 2150,
    status: { titleAr: 'لم يتم التوصيل', titleEn: 'Not Delivered' },
    createdAt: new Date('2026-01-29T16:45:10'),
    createdBy: 'شركة الشحن',
  }
];

  emptyContentTitle = {
    ar: 'لا توجد بيانات متاحة',
    en: 'No data available',
  };


    actions = signal([
    {
      id: 1,
      titleEn: 'View Details',
      titleAr: 'عرض التفاصيل ',
    },
  ]);

  

isFiltersApplied = computed(() => {
  return (
    !!this.orderSearch() ||
    !!this.selectedPharmacyFilter() ||
    this.selectedStatuses().length > 0 ||
    !!this.createdFrom() ||
    !!this.createdTo() ||
    !!this.createdBySearch()
  );
});

handleAction(event: { event: Event; actionId: number; entity: any }) {
    console.log('Action Triggered:', event.actionId, event.entity);
    if (event.actionId === 1) {
  
    }
  }
  


  totalPages = computed(() => Math.max(1, Math.ceil(this.totalItems() / this.itemsPerPage())));

  startItem = computed(() => {
    if (this.totalItems() === 0) {
      return 0;
    }

    return (this.currentPage() - 1) * this.itemsPerPage() + 1;
  });

  endItem = computed(() => Math.min(this.currentPage() * this.itemsPerPage(), this.totalItems()));

  getPageNumbers() {
    return Array.from({ length: this.totalPages() }, (_, index) => index + 1);
  }

  onPreviousPage() {
    if (this.currentPage() > 1) {
      this.currentPage.update((page) => page - 1);
    }

  }

  onNextPage() {
    if (this.currentPage() < this.totalPages()) {
      this.currentPage.update((page) => page + 1);
    }

  }

  onGoToPage(page: number) {
    if (page >= 1 && page <= this.totalPages()) {
      this.currentPage.set(page);
    }

  }

  onChangePageNumber(page: number) {
    this.onGoToPage(page);
  }

  onPageSizeChange() {
    this.currentPage.set(1);
  }
}
